/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateCurrentUserInfoRequest { 
    firstName: string;
    lastName?: string | null;
    telegramLogin?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
}

